var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('Tabs',{ref:"Tabs",attrs:{"form":_vm.form,"model":_vm.model}}):_c('Wizard',{ref:"Wizard",attrs:{"form":_vm.form,"model":_vm.model},on:{"finish":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }